import React, { useEffect, useState } from "react";
import * as moment from "moment";
import { useToasts } from "react-toast-notifications";
import UserDefaultAvatar from "assets/img/user.svg";
import VideoPlayer from "components/VideoPlayer";
import AudioPlayer from "components/AudioPlayer";
import TeamService from "services/TeamService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRepliesContext } from "store/contexts/repliesContext";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useHistory } from "react-router-dom";
import Linkify from "react-linkify";
import MediaPreview from "components/MediaPreview/MediaPreview";
import { useGlobalContext } from "store/contexts/globalContext";
import DocumentPreview from "components/DocumentPreview";
import LazyLoadImage from "components/LazyLoadImage";
import ReplyFooter from "./ReplyFooter";

var styles = {
  mediaComment: {
    padding: "10px",
    flex: 1,
    border: "none",
  },
  commentImage: {
    maxWidth: "300px",
    width: "100%",
    maxHeight: "300px",
    objectFit: "contain",
  },
  mediaContent: {
    fontSize: "0.875rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.43,
    paddingTop: "8px",
  },
  commentVideo: {
    maxWidth: "400px",
  },
  playMessage: {
    maxWidth: "400px",
    position: "absolute",
    gap: "10px",
    top: 0,
    left: 0,
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    alignItems: "center",
    height: "100%",
  },
  playIcon: {
    width: "80px",
    height: "40px",
    cursor: "pointer",
    "&:hover": {
      opacity: "0.8",
    },
  },
  cancelAudio: {
    backgroundColor: "#1e232c",
    display: "flex",
    justifyContent: "flex-end",
    color: "white",
    padding: "5px",
  },
  audioText: {
    fontSize: "16px",
  },
  documentContent: {
    fontSize: "0.875rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.43,
    paddingTop: "8px",
    paddingBottom: "10px",
  },
};

export default ({ reply, listTask }) => {
  let history = useHistory();
  const classes = styles;
  const { addToast } = useToasts();
  const [teamRole, setTeamRole] = useState();
  const { deleteReply } = useRepliesContext();
  const [showAudio, setShowAudio] = useState(false);
  const [timeDifference] = useState(moment(reply.created_at).fromNow());
  const { checkYourTeamRole } = useGlobalContext();

  useEffect(() => {
    (async () => {
      try {
        var response = await checkYourTeamRole(listTask.post.team_id);
        setTeamRole(response);
      } catch (e) {
        console.log(e);
      }
    })();

    //eslint-disable-next-line
  }, []);

  const deleteMyExpression = async () => {
    try {
      await TeamService.deleteListItemExpression(
        listTask.post.team_id,
        listTask.todo_list_id,
        listTask.id,
        reply.id
      );

      deleteReply(reply);
      addToast("your comment is deleted ", { appearance: "success" });
    } catch (e) {
      console.log(e);
    }
  };

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  return (
    <div className="user-comments mt-3">
      <img
        onClick={() => showUserProfile(reply?.user?.id)}
        style={{ cursor: "pointer" }}
        className="user-img-comment mw-40"
        src={reply?.user?.avatar ?? UserDefaultAvatar}
        alt={`${reply?.user?.avatar}`}
      />
      <div className="p-user-comment">
        <span className="p-username ff-montserat fw-600 fs-12">
          {reply?.user?.full_name}
        </span>
        <small className="p-comment-time pl-10 fs-12">
          Posted {timeDifference}
        </small>
        {reply?.media_type === "text" && (
          <Linkify
            properties={{
              target: "_blank",
              style: { color: "red", fontWeight: "bold" },
            }}
          >
            <p className="p-comment-content">{reply?.content}</p>
          </Linkify>
        )}
        {reply?.media_type === "document" && (
          <>
            <DocumentPreview expression={reply} />
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              <div
                style={classes.documentContent}
                className="p-comment-content"
              >
                {reply?.content}
              </div>
            </Linkify>
          </>
        )}
        {reply?.media_type === "video" && (
          <div style={classes.mediaComment}>
            <div style={classes.commentVideo}>
              <VideoPlayer
                src={reply.media}
                mediaCaptions={reply.media_captions.vtt}
              />
            </div>
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              <div style={classes.mediaContent} className="p-comment-content">
                {reply?.content}
              </div>
            </Linkify>
          </div>
        )}
        {reply?.media_type === "photo" && (
          <div style={classes.mediaComment}>
            <MediaPreview attachment={reply?.media} type={reply?.media_type}>
              <LazyLoadImage
                image={reply?.media}
                style={classes.commentImage}
                alt={`${reply?.media_type}`}
                key={`${reply?.media_type}`}
              />
            </MediaPreview>
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              <div style={classes.mediaContent} className="p-comment-content">
                {reply?.content}
              </div>
            </Linkify>
          </div>
        )}
        {reply?.media_type === "audio" && !showAudio && (
          <div style={classes.mediaComment}>
            <div style={{ position: "relative" }}>
              <div
                style={{
                  backgroundColor: "black",
                  width: "100%",
                  maxWidth: "400px",
                  height: "200px",
                }}
              ></div>
              <div style={classes.playMessage}>
                <span style={classes.audioText}>Click to play the audio</span>
                <FontAwesomeIcon
                  onClick={() => setShowAudio(true)}
                  icon={faPlayCircle}
                  style={classes.playIcon}
                />
              </div>
            </div>
            <Linkify
              properties={{
                target: "_blank",
                style: { color: "red", fontWeight: "bold" },
              }}
            >
              <div style={classes.mediaContent} className="p-comment-content">
                {reply?.content}
              </div>
            </Linkify>
          </div>
        )}
        {showAudio && (
          <div style={{ paddingBottom: "15px" }}>
            <div style={classes.cancelAudio}>
              <CancelIcon
                style={{ cursor: "pointer", width: "15px", height: "15px" }}
                onClick={() => setShowAudio(false)}
              />
            </div>
            <AudioPlayer autoplay={true} src={reply.media} />
            <div style={classes.mediaContent} className="p-comment-content">
              {reply?.content}
            </div>
          </div>
        )}
        <ReplyFooter
          listTask={listTask}
          reply={reply}
          teamRole={teamRole}
          deleteMyExpression={deleteMyExpression}
        />
      </div>
    </div>
  );
};
